import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      '&:hover': {
        color: theme.palette.denim[500]
      },
      '&:focus': {
        color: theme.palette.denim[500]
      },
      '&$active': {
        color: theme.palette.denim[500]
      },
      '&$active $icon': {
        color: `${theme.palette.denim[500]} !important`
      }
    },
    active: {},
    icon: {
      opacity: 0.5
    }
  };
}, {
  name: 'pds-table-sort-label'
});